import { render, staticRenderFns } from "./ad_type.vue?vue&type=template&id=61514fc0"
import script from "./ad_type.vue?vue&type=script&lang=js"
export * from "./ad_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports